/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityInputDialogComponent } from '@gh/common-internal-shared';
import { createDialogRoute } from '@gh/common-shared';

import { CommunityListBusinessService } from '../../resources/community-list-business.service';

export const communityDetailsDialog = createDialogRoute({
  component: EntityInputDialogComponent,
  init: CommunityListBusinessService,
});
